import React from 'react';
import '../../../../styles/MapContainer.css';
import PropTypes from 'prop-types';

const MapContainer = ({ customClass = '' }) => {
  return (
    <div className={`rlMapCont ${customClass ? customClass : ''}`}>
      <iframe
        title={'google-map'}
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d55310.906042368246!2d78.08090631870444!3d29.952645220320047!2m3!1f0!2f0!3f0!3m2!1i1024!2i767!4f13.1!3m3!1m2!1s0x3909470eb8ee57c9%3A0x4e449176a640f5f3!2sHaridwar%2C%20Uttarakhand!5e0!3m2!1sen!2sin!4v1616473485266!5m2!1sen!2sin"
        style={{ border: 0 }}
        loading="lazy"
      ></iframe>
    </div>
  );
};

MapContainer.propTypes = {
  customClass: PropTypes.string
};

export default MapContainer;
